import { WindowState } from '../state';
import { HandleFinish } from '../types';

const FINISH_OPTIONS: { value: HandleFinish; label: string }[] = [
  { value: 'chrome', label: 'Chrome' },
  { value: 'black', label: 'Black' },
  { value: 'white', label: 'White' },
  { value: 'brushed-steel', label: 'Brushed Steel' },
];

export function createHardwareSelector(state: WindowState): HTMLElement {
  const container = document.createElement('div');

  const row = document.createElement('div');
  row.className = 'opt-row';

  const label = document.createElement('span');
  label.className = 'opt-label';
  label.textContent = 'Handle';

  const select = document.createElement('select');
  select.className = 'opt-select';

  const currentFinish = state.config.sections[0]?.hardware.handleFinish ?? 'chrome';

  for (const opt of FINISH_OPTIONS) {
    const option = document.createElement('option');
    option.value = opt.value;
    option.textContent = opt.label;
    if (currentFinish === opt.value) option.selected = true;
    select.appendChild(option);
  }

  select.addEventListener('change', () => {
    const finish = select.value as HandleFinish;
    for (let i = 0; i < state.config.sections.length; i++) {
      state.setHandleFinish(i, finish);
    }
  });

  row.appendChild(label);
  row.appendChild(select);
  container.appendChild(row);

  return container;
}
